<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            @close="closeDialog"
    >
        <el-form
                :model="dataForm"
                ref="dataForm"
                @keyup.enter.native="dataFormSubmit()"
                label-width="120px"
        >
            <el-form-item label="数据源" prop="datasourceId">
                <el-select v-model="dataForm.datasourceId" placeholder="数据源"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in datasourceList"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="表单编号" prop="code">
                <el-input v-model="dataForm.code" placeholder="表单编号"></el-input>
            </el-form-item>
            <el-form-item label="表单标题" prop="title">
                <el-input v-model="dataForm.title" placeholder="表单标题"></el-input>
            </el-form-item>
            <el-form-item label="表单类型" prop="formType">
                <el-select v-model="dataForm.formType" placeholder="表单类型"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in formTypeList"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
          <el-form-item label="业务类型" prop="formType">
            <el-select v-model="dataForm.busType" placeholder="业务类型"
                       style="display: block;margin-bottom: 10px">
              <el-option
                  v-for="item in busTypeList"
                  :key="item.type"
                  :label="item.text"
                  :value="item.type">
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="是否支持附件" v-if="dataForm.formType==1" prop="hasAttach">
                <el-select v-model="dataForm.hasAttach" placeholder="是否支持附件"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否支持流程" v-if="dataForm.formType==1" prop="hasFlow">
                <el-select v-model="dataForm.hasFlow" placeholder="是否支持流程"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="流程模板键值" v-if="dataForm.formType==1" prop="flowTemplateKey">
                <el-input
                        v-model="dataForm.flowTemplateKey"
                        placeholder="流程模板键值"
                ></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="dataSort">
                <el-input
                        v-model="dataForm.dataSort"
                        placeholder="排序"
                ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    const fromData = {
        id: "",
        name: "",
        description: "",
        datasourceId: "",
        formType: 1,
        hasAttach: false,
        hasFlow: false,
        flowTemplateKey: '',
        dataStatus: 0,
        dataSort: 10
    }
    export default {
        props: ["mainContentViewHeight"],
        data() {
            return {
                visible: false,
                datasourceList: [],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                formTypeList: [{id: 0, text: '列表'}, {id: 1, text: '明细'}],
                busTypeList: [{type: 'GC', text: '工程建设'}, {type: 'CG', text: '政府采购'}, {type: 'GT', text: '国有产权'}, {type: 'CQ', text: '农村产权'}],
                dataForm: fromData,
            };
        },
        methods: {
            initSelectData() {
                this.$http
                    .post(this.$http.adornUrl("/customform/datasourceconfig/nodeList"),{},{baseURL: ''})
                    .then(({data}) => {
                        this.datasourceList = data;
                    });
            },
            init(id) {
                this.dataForm.id = id || "";
                this.visible = true;
                this.initSelectData()
                if (this.dataForm.id) {
                    this.$http({
                        url: this.$http.adornUrl("/customform/get?id=" + this.dataForm.id),
                        method: "get",
                        baseURL: '',
                    }).then(({data}) => {
                        if (data && data.code === "1") {
                            this.dataForm = data.data;
                        } else {
                            this.dataForm = fromData;
                        }
                    });
                }
            },
            closeDialog() {
                this.visible = false;
                this.dataForm = fromData;
            },
            // 表单提交
            dataFormSubmit() {
                this.$http({
                    url: this.$http.adornUrl("/customform/save"),
                    method: "post",
                    baseURL: '',
                    data: this.dataForm,
                }).then(({data}) => {
                    if (data && data.code === "1") {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.visible = false;
                                this.$emit("refreshDataList");
                            },
                        });
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            },
        },
    };
</script>
